<template>
    <div>
        <upgrade></upgrade>
    </div>
</template>

<script>
import Upgrade from '@/components/Upgrade.vue';
export default {
    name: 'upgradepage',
    data : function () {
        return {
            //
        }
    },
    created : function () {
        if (this.$root.device.platform == 'iOS') {
            // load up equivalent page in browser
            window.open('https://app.ghostapp.co.uk', '_system')
            this.$router.replace({'name' : 'profile'});
        }
    },
    mounted : function () {
        //
    },
    components : {
        Upgrade
    }
}
</script>>
